export default __webpack_public_path__ + "static/media/Stress1.2971fe15.jpeg";